module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "static-col static-row"
  }, [_vm._v("Reservas")]), _vm._v(" "), _vm._l((_vm.dateArray), function(day, indexDay) {
    return _c('div', {
      key: indexDay
    }, [_vm._v(_vm._s(day))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af09c34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/DateHeader.vue
// module id = 1219
// module chunks = 1 20